const phoneMask = (input: string) => {
  input = input || '';

  const formatedValue = input.match(/[+0-9]+/g);

  return `${formatedValue || ''}`;
};

export default phoneMask;
